import { BroadcastersOverlayPlayerQueryI } from '../../../../pages/projects/ViewVideoProject/models';
import styles from './styles.module.scss';

interface LogoClockPreviewI {
    broadcastersOverlayPlayerData: BroadcastersOverlayPlayerQueryI
    currentBroadcaster: { value: number, label: string } | undefined
    hideLogo?: boolean;
    hideClock?: boolean;
}

export const LogoClockPreview = ({ currentBroadcaster, hideLogo, hideClock, broadcastersOverlayPlayerData }: LogoClockPreviewI) => {
    const broadcaster = broadcastersOverlayPlayerData?.Broadcasters?.find((broadcaster) => broadcaster?.Id === currentBroadcaster?.value)

    if (!broadcaster) return null

    return <div className={styles.logoClockPreview}>
        {broadcaster.BroadcasterLogo.ImageSource && !hideLogo ?
            (<img
                className={styles.broadcasterLogo}
                src={broadcaster.BroadcasterLogo.ImageSource} alt="Broadcaster Logo"
                style={{
                    top: broadcaster.BroadcasterLogo.OffsetTop,
                    [broadcaster.BroadcasterLogo.LogoPosition]: broadcaster.BroadcasterLogo.OffsetSide,
                }}
            />) : null}
        {broadcaster.ClockLogo.ImageSource && !hideClock ? (<img
            className={styles.clockLogo}
            src={broadcaster.ClockLogo.ImageSource}
            style={{
                top: broadcaster.ClockLogo.OffsetTop,
                [broadcaster.ClockLogo.ClockPosition]: broadcaster.ClockLogo.OffsetSide,
            }}
            alt="Clock Logo"
        />) : null}
    </div>
};